import apolloClient from 'api/apolloClient';
import { GENERATE_FILES_FOR_AUTO_RENEW, GENERATE_MAINTENANCE } from 'api/queries/biReportService';
import { FileType } from 'types/biReportService';

export async function generateMaintenance(type: FileType, recipients: string[]): Promise<boolean> {
  return (
    await apolloClient.mutate<{ generateMaintenance: boolean }>({
      mutation: GENERATE_MAINTENANCE,
      fetchPolicy: 'no-cache',
      variables: { type, recipients },
    })
  ).data!.generateMaintenance;
}

export async function generateFilesForAutoRenew(
  sponsorId: string,
  effectiveDate: string,
  recipients: string[],
): Promise<boolean> {
  return (
    await apolloClient.mutate<{ generateFilesForAutoRenew: boolean }>({
      mutation: GENERATE_FILES_FOR_AUTO_RENEW,
      fetchPolicy: 'no-cache',
      variables: { sponsorId, effectiveDate, recipients },
    })
  ).data!.generateFilesForAutoRenew;
}
